import React from 'react';
import { P60ModulePage as P60ModulePageType } from '~/lib/data-contract';
import { DynamicBlockList } from '~/templates/blocks';
import { usePage } from '~/templates/pages';

export const P60ModulePage = () => {
    const { pageElements = [] } = usePage<P60ModulePageType>();
    return <DynamicBlockList elements={pageElements} />;
};
